import { Fragment, useState } from "react";
import { DebouncedInput } from "../../components/debounced-input.component";
import { GoogleMaps } from "../../components/maps.component";
import { useMapsHook } from "../../hooks/maps.hook";
import './address.slide.css';

export const AddressSlide = ({
    text,
    latitude,
    longitude,
    onAddressChange,
    onContinue
}: {
    text: string;
    latitude: number;
    longitude: number;
    onAddressChange: (text: string, latitude: number, longitude: number) => void;
    onContinue: () => void;
}) => {
    // State
    const [searchState, setSearchState] = useState<'bouncing' | 'searching' | 'completed'>('completed');

    // Hooks
    const {
        geolocations,
        getGeocodingLocations,
        setGeolocations
    } = useMapsHook();

    // Functions
    const searchGeocodingLocations = (text: string) => {
        setSearchState('searching');
        getGeocodingLocations(text).finally(() => {
            setSearchState('completed');
        });
    }
    
    return (<Fragment>
        <div onClick={() => {
            // Revert
            setGeolocations([]);
        }} className={`geolocations-options--overlay${!!geolocations.length ? ' show' : ''}`} />
        <div className="row address">
            <div className="col-6">
                <h2>
                    Introduce <span className="inverted">la dirección</span> donde quieres realizar la instalación.
                </h2>
                <hr className="separator green-gradient"></hr>
                <p className="p-large">
                    Así, nos permetirás conocer la radiación solar de la zona y podemos obtener <strong>las características</strong> de tu tejado.
                </p>
                <div className="fake-input">
                    <img src={require("../../assets/large-address-icon.png")} height="32" width="32" alt="Address" />
                    <DebouncedInput
                        type="text"
                        name="address"
                        onChange={searchGeocodingLocations}
                        controlledValue={text}
                        placeholder={"Av. Progrés, 3A, 46530 Puçol, Valencia, Spain"}
                        wait={1000}
                        onDebounced={() => {
                            setSearchState('bouncing');
                        }}
                    />
                    <div className="geolocation-options">
                        {
                            (searchState !== "completed") 
                                && <div className="geolocation-options--option search">Buscando...</div>
                        }
                        {
                            geolocations.slice(0, 3).map((location, i) => 
                                <div 
                                    key={`geolocation-options--option--${i}`}
                                    className="geolocation-options--option"
                                    onClick={() => {
                                        onAddressChange(location.formatted_address, location.geometry.location.lat, location.geometry.location.lng);
                                        setGeolocations([]);
                                    }}>
                                    {location.formatted_address}
                                </div>
                            )
                        }
                    </div>
                </div>
                <button disabled={!text} className="button" onClick={onContinue}>
                    Continuar
                </button>
            </div>
            <div className="col-6">
                <GoogleMaps id="address-map" latitude={latitude} longitude={longitude} />
            </div>
        </div>
    </Fragment>);
}